import React, { useEffect, useState } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import AppButton from "../../components/button";
import AppTextField from "../../components/text-field";
import { validatePassword } from "../../utils/validation";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { APP_NAVIGATION, LOCALE } from "../../utils/constants";
import PathHelper from "../../utils/path-helper";

const ResetPassword = ({ resetPasswordConnect }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const uId = searchParams.get("uid") && searchParams.get("uid").trim();
  const token = searchParams.get("cd");
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;
  const loginPath = PathHelper(APP_NAVIGATION.SINI, currentLocale);

  const splittedValues = location.search.split("&");
  // const token = splittedValues
  //   .find((item) => item.includes("cd"))
  //   .split("=")[1];

  // Replace spaces with "+"
  const decodedToken = token ? token.replace(/ /g, "+") : "";

  const cd = decodedToken && decodedToken?.trim();

  const [formData, setFormData] = useState({
    password: "",
  });

  const [error, setError] = useState({
    passwordError: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let error = "";
    if (name === "password") {
      error = validatePassword(value, t);
    }
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
    setError((prevError) => ({ ...prevError, [`${name}Error`]: error }));
  };

  const handleResetPassword = (event) => {
    event.preventDefault();
    const { password } = formData;
    const isPwdError = validatePassword(password?.trim(), t);
    if (isPwdError.length > 0) {
      setError((prevError) => ({ ...prevError, passwordError: isPwdError }));
    } else {
      setError((prevError) => ({ ...prevError, passwordError: "" }));
    }
    if (isPwdError.length > 0) return;
    const params = {
      token: cd,
      userGuid: uId,
      newPassword: password,
    };
    resetPasswordConnect(params)
      .then((response) => {
        if (response && typeof response === "object") {
          if (response.passwordReset === true && response.error === null) {
            toast.success(t("settings.reset_password_success_msg"));
            navigate(loginPath.next);
          } else {
            toast.error(t("settings.reset_password_fail_msg"));
          }
        } else {
          // Handle unexpected response structure
          toast.error(t("settings.unexpected_resp_err_msg"));
        }
      })
      .catch((error) => {
        // Handle any errors that occur during the API call
        console.error("Error during password reset:", error);
        toast.error(
          "An error occurred while resetting the password. Please try again."
        );
      });
    // resetPasswordConnect(params).then((response) => {
    //   console.log("SKKSK", response);
    //   if (
    //     response &&
    //     response?.passwordReset === true &&
    //     response?.error === null
    //   ) {
    //     toast.success("Reset Password Sucessfully!!");
    //     navigate(ROUTE_CONSTANT.LOGIN);
    //   } else {
    //     toast.error("Password reset failed. Please request a new link.");
    //   }
    // });
  };

  return (
    <>
      <Header />
      <div className="p-5 text-center bg-white flex-grow">
        <h1 className="font-bold color-[#444C5E] text-4xl mb-4">
          {t("account.reset_password_text")}
        </h1>

        <div className="flex justify-center mt-8">
          <form
            id="reset-password-form"
            className="space-y-4 w-full max-w-xs"
            onSubmit={handleResetPassword}
          >
            <AppTextField
              id="reset-password-input"
              label={t("account.new_password_label")}
              name="password"
              onChange={handleInputChange}
              value={formData.password}
              error={error.passwordError}
              type="password"
              placeholder={t("account.new_password_placeholder")}
            />

            <AppButton
              id="reset-password-submit-button"
              type="submit"
              className="bg-[#FE6634] cursor-pointer text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
            >
              {t("account.reset_password_text")}
            </AppButton>
          </form>
        </div>
      </div>

      <Footer className="fixed" />
    </>
  );
};

export default ResetPassword;
